module.exports = __webpack_public_path__ + "media/site/images/products/bip-screen-06ad5b368e3a8ed8914deff6c40f0b9f.png";